var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "card-header-title" }, [
          _c("img", { attrs: { src: "/images/favicon-32x32.png" } }),
          _vm._v("\n       \n      "),
          _c("h4", { staticClass: "title is-4" }, [
            _vm._v("\n        Can the wheel be rigged?\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "content" }, [_vm._v("\n      ...\n    ")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }